/**
 * Environment configuration for the application.
 */
export const environment = {
  production: false, // Indicates if the build is for production

  // Node API base URL for development
  // nodeApiUrl: 'http://localhost:5001/api', // Local development server
  nodeApiUrl: 'https://dev.remmi.com.au/api',
  salePresentation: 'https://dev-sales-presentation.remmi.com.au',
  wsEndpoint: 'wss://devws.remmi.com.au/', // WebSocket endpoint

  // nodeApiUrl: 'https://staging.remmi.com.au/api',
  // salePresentation: 'https://staging-sales-presentation.remmi.com.au',
  // wsEndpoint: 'wss://stagingws.remmi.com.au/', // WebSocket endpoint

  // nodeApiUrl: 'https://live.remmi.com.au/api',
  // salePresentation: 'https://sales-presentation.remmi.com.au',
  // wsEndpoint: 'wss://livews.remmi.com.au/', // WebSocket endpoint

  api_prefix: 'v1', // API version prefix
  // Serves ONLY the New Project Insight report's content endpoints (see
  // docs/backend/FRONTEND-NEW-PROJECT-INSIGHT-2026-09-15.md). Never make this the global
  // api_prefix: only the paths in that document exist on v2, so every other call would 404.
  api_prefix_v2: 'v2',

  // Secret key (don't hardcode in production!)
  secretKey: 'a3f1c45e9b872d3a5e42907bfa62cba2e1c6f9f7389dc6a7f182b06c447b2ae1',

  // S3 bucket URLs
  S3: 'https://remmi-xm.s3-ap-southeast-2.amazonaws.com',
};
